<template>
  <div class="eventOnlineTableCellLabels">
    <div class="label" v-for="(label, index) in programLabels" :key="index">
      {{ label }}
    </div>
    <div
      v-if="beforeProgramStart(programStartTime)"
      class="label label--primary-outline label--rounded"
    >
      配信待ち
    </div>
    <div
      v-else-if="afterProgramEnd(ProgramEndTime)"
      class="label label--muted label--rounded"
    >
      配信終了
    </div>
    <div
      v-else-if="nowOnAir(programStartTime, ProgramEndTime)"
      class="label label--primary label--rounded"
    >
      配信中
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import {
  isNowBeforeTimeString,
  isNowAfterTimeString,
  isNowBetweenTwoTimeString,
} from '@/utils/eventDetailOnlineTableUtils'

export default defineComponent({
  name: 'EventDetailOnlineTableCellLabels',
  props: {
    currentDate: {
      type: String, // YYYY-M-D H:m
      default: ''
    },
    eventDate: {
      type: String, // YYYY-MM-DD HH:mm:ss
      default: ''
    },
    programLabels: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    programStartTime: {
      type: String, // HH:mm
      default: ''
    },
    ProgramEndTime: {
      type: String, // HH:mm
      default: ''
    }
  },
  setup(props) {
    const beforeProgramStart = computed(() => {
      return isNowBeforeTimeString(props.currentDate, props.eventDate)
    })
    const afterProgramEnd = computed(() => {
      return isNowAfterTimeString(props.currentDate, props.eventDate)
    })
    const nowOnAir = computed(() => {
      return isNowBetweenTwoTimeString(props.currentDate, props.eventDate)
    })
    return {
      beforeProgramStart,
      afterProgramEnd,
      nowOnAir
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/variables' as var;

.eventOnlineTableCellLabels {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.label {
  font-size: 10px;
  line-height: 1;
  padding: 4px;
  background-color: var.$color-secondary;
  display: inline-block;
  margin-bottom: 10px;
  margin-right: 5px;

  &--primary {
    background-color: var.$color-primary;
    color: #fff;

    &-outline {
      padding: 3px;
      background-color: transparent;
      border: 1px solid var.$color-primary;
      color: var.$color-primary;
    }
  }

  &--muted {
    background-color: #d3d3d3;
    color: #fff;
  }

  &--rounded {
    border-radius: 3px;
  }
}
</style>
